/**
 * Attività di Trattamento — coreBOS `ProcessingActivities` (71x) on evo-gdpr.evolutivo.it.
 * Harvested from evo-mcp-limitless@origin/evo-policies by scripts/harvest/gen_descriptors.py.
 * Frameworks: gdpr. Type sources per field: docs/harvest-report.md.
 * Regenerate instead of hand-editing; hand edits belong in the generator's SPEC.
 */
export const processingActivityDescriptor = {
    slug: 'cmp_processing_activity',
    kind: 'document',
    label: { singular: 'Attività di Trattamento', plural: 'Attività di Trattamento' },
    table: 'compliance_processing_activity',
    idStrategy: 'sha256',
    fields: [
        { name: 'processingname', type: 'text', label: 'Nome Trattamento', required: true },
        { name: 'id_trattamento', type: 'text', label: 'Codice (DB)' },
        { name: 'purpose_of_processing', type: 'text', label: 'Finalità' },
        { name: 'legal_basis', type: 'text', label: 'Base Giuridica' },
        { name: 'categories_of_data_subjects', type: 'text', label: 'Categorie Interessati' },
        { name: 'categories_of_personal_data', type: 'text', label: 'Categories of personal data' },
        { name: 'categories_of_recipients', type: 'text', label: 'Categories of recipients' },
        { name: 'transfers_to_third_countries', type: 'text', label: 'Transfers to third countries' },
        { name: 'erasure_time_limits', type: 'text', label: 'Erasure time limits' },
        { name: 'security_measures', type: 'text', label: 'Security measures' },
        { name: 'processing_risk_level', type: 'text', label: 'Processing risk level' },
        { name: 'processing_methods', type: 'text', label: 'Processing methods' },
        { name: 'data_protection_officer', type: 'text', label: 'Data protection officer' },
        { name: 'internal_responsible', type: 'text', label: 'Internal responsible' },
        { name: 'description', type: 'text', label: 'Description' },
        { name: 'processing_start_date', type: 'date', label: 'Processing start date' },
        { name: 'processing_end_date', type: 'date', label: 'Processing end date' },
        { name: 'external_processors', type: 'text', label: 'External processors' },
        { name: 'is_template', type: 'boolean', label: 'Template' },
    ],
    relations: [
        { name: 'rel_account', kind: 'belongsTo', target: 'account', toEntitySpine: true },
        { name: 'relatedaccount', kind: 'belongsTo', target: 'account', toEntitySpine: true },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
    ],
    behaviors: { ownership: true, audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'DatabaseOutlined', navGroup: 'GDPR' },
};
